export default "__VITE_ASSET__DXwQYxJW__"